import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "../../container/language";
import Link from "../../utils/Link";
import News from "./news";

import "./style.scss";

const newsTypeLabels = {
  NEWS: "njoftime",
  PUBLICATION: "publikime",
  ACTIVITY: "aktivitete",
  RECRUITMENT: "rekrutime",
};

const NewsList = ({ data, type }) => {
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  return (
    <div className="row">
      <div className="col-12 col-md-9 col-lg-10">
        <ul class="news-list" style={{ paddingLeft: "0px" }}>
          {data.map((news) => (
            <News {...news} type={type} />
          ))}
        </ul>
      </div>
      <div className="col-12 col-md-3 col-lg-2">
        <div className="widget">
          {["NEWS", "ACTIVITY", "RECRUITMENT"].map((itemType) => {
            return (
              <Link to={`/lajme/${newsTypeLabels[itemType]}`}>
                <h4
                  className={`widget-title mb-3 ${
                    itemType === type ? "text-primary" : "text-dark"
                  }`}
                >
                  <i className="i-arrow-right"></i>{" "}
                  {t(`pages.news.types.plural.${itemType}`)}
                </h4>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default NewsList;
